module.exports = __webpack_public_path__ + "static/media/keyoperation4.d2e3a201.png";